import { Button, Div, ModalPortal, P } from '@vgrubs/components';

export const ApplyToAllBrandsModal = ({
  isOpen,
  setIsOpen,
  handleSubmit,
  text,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleSubmit: (applyToAllBrands: boolean) => void;
  text: string;
}) => {
  return (
    <ModalPortal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      overflow="visible"
      zIndex={131}
      exitButton={false}
    >
      <Div $flex $column $gap="24px" $mt="4">
        <P $m="0" $center>
          {text}
        </P>
      </Div>
      <Div $flex $center $mt="32" $gap="16px">
        <Button $w="100%" $selected onClick={() => handleSubmit(true)}>
          Yes
        </Button>
        <Button $w="100%" $selected $gray onClick={() => handleSubmit(false)}>
          No
        </Button>
      </Div>
    </ModalPortal>
  );
};
